import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.5 0h-7C3.7 0 3 .7 3 1.5v13c0 .8.7 1.5 1.5 1.5h7c.8 0 1.5-.7 1.5-1.5v-13c0-.8-.7-1.5-1.5-1.5m.5 14.5c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-1h8zm0-2H4v-9h8zm0-10H4v-1c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5z" />
  </svg>
);
const SvgPhone = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="phone" {...props} />;
export default SvgPhone;
